import styled from 'styled-components';

import { color } from '../../../../atoms/colors';
import { font } from '../../../../atoms/typography';
import { spacing } from '../../../../atoms/spacing';
import { atMinWidth } from '../../../../atoms/breakpoints';

import {
  defaultStyles,
  variants,
  sizes,
} from '../../../CallToAction/styles/CallToAction.styled';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: ${spacing[16]};
  background: ${color.midnight[25]};
  box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03),
    0px 20px 24px -4px rgba(16, 24, 40, 0.08);
  overflow: hidden;
`;

export const Form = styled.form`
  width: 100%;
  padding: ${spacing[24]} ${spacing[16]};
  display: flex;
  flex-direction: column;

  ${atMinWidth.sm`
    padding: ${spacing[32]} ${spacing[40]};
  `}
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${spacing[12]};

  .use-policy {
    p {
      ${font('text', 'xs', '400')}
      color: ${color.darkBlue[700]};
      text-align: center;
    }
    a {
      ${font('text', 'xs', '400')}
      color: ${color.blue[700]};
    }
  }
`;

export const Button = styled.button`
  width: 100%;
  text-align: center;
  transition: all 250ms ease-in-out;
  ${defaultStyles}
  ${variants['Filled - Blue']}
  ${sizes.md}
  margin-top: 12px;
`;
